import type { IndependentAction } from './actions'

export enum EVENT_TYPE {
    'CLICK' = 'CLICK',
    'LOAD' = 'LOAD',
    'CHANGE' = 'CHANGE',
    'MOUSE_ENTER' = 'MOUSE_ENTER',
    'MOUSE_LEAVE' = 'MOUSE_LEAVE',
    'SCROLL_BOTTOM' = 'SCROLL_BOTTOM',
    'RECORD_CLICK' = 'RECORD_CLICK',
    'ENTER' = 'ENTER',
    'SUBMIT' = 'SUBMIT',
    'SOCKET' = 'SOCKET',
    'FOCUS' = 'FOCUS',
    'BLUR' = 'BLUR',
    'LOAD_DATA' = 'LOAD_DATA',
    'LEFT_SWIPE' = 'LEFT_SWIPE',
    'RIGHT_SWIPE' = 'RIGHT_SWIPE',
    'PLAY' = 'PLAY',
    'TIMER' = 'TIMER'
}

export enum DELAY_TYPE {
    'THROTTLE' = 'THROTTLE',
    'DEBOUNCE' = 'DEBOUNCE',
    'NONE' = 'NONE'
}

export type EventConfig = {
    delayRunConfig?: {
        type: DELAY_TYPE
        time?: number
    }
}

export type ScrollEventConfig = EventConfig & {
    bottom: number
}

export enum TIMER_TRIGGER_MODE {
    'ONCE' = 'ONCE',
    'REPEAT' = 'REPEAT'
}

export enum TIMER_INTERVAL_UNIT {
    'SECOND' = 'SECOND',
    'MINUTE' = 'MINUTE'
}

export type TimerIntervalPreset = '1s' | '3s' | '5s' | '10s' | '30s' | '1m' | '5m' | '10m' | '30m' | 'CUSTOM'

export type TimerEventConfig = EventConfig & {
    triggerMode: TIMER_TRIGGER_MODE
    intervalPreset: TimerIntervalPreset
    customInterval?: number
    customIntervalUnit?: TIMER_INTERVAL_UNIT
}

export interface EventConfigure {
    id: string
    type: EVENT_TYPE
    actions: IndependentAction[]
}

export type ScrollEventProtocol = Record<'type', EVENT_TYPE.SCROLL_BOTTOM> &
    EventConfigure & {
        config: ScrollEventConfig
    }

export type OtherEventProtocol = Record<'type', EVENT_TYPE> &
    EventConfigure & {
        config: EventConfig
    }

export type TimerEventProtocol = Record<'type', EVENT_TYPE.TIMER> &
    EventConfigure & {
        config: TimerEventConfig
    }

export type ActorEvent = ScrollEventProtocol | TimerEventProtocol | OtherEventProtocol

export interface EventsProtocol {
    eventList?: ActorEvent[]
}
